var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.225,
    height: 312.808,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6034.202 2747.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -2746.811,
    x: 6034.701,
    height: 311.811,
    width: 223.228,
    rx: 10.63,
    ry: 10.63,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.997
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d40000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6123.944-2590.774c9.92-9.682 16.436-20.238 22.667-30.39 5.464 11.17 13.306 20.943 21.786 30.39-9.073 9.368-16.105 19.386-21.76 29.917-6.267-10.795-12.865-20.571-22.693-29.917zM6230.93-2497.773c4.063-3.966 6.732-8.29 9.285-12.449 2.238 4.576 5.45 8.58 8.924 12.449-3.717 3.838-6.597 7.941-8.913 12.255-2.568-4.422-5.27-8.427-9.297-12.255zM6042.55-2683.46c4.063-3.966 6.732-8.29 9.285-12.449 2.238 4.576 5.45 8.579 8.924 12.449-3.716 3.838-6.597 7.941-8.913 12.255-2.568-4.422-5.27-8.427-9.297-12.255zM6041.936-2700.745v-2.737h2.66l5.665-29.272h3.223l6.243 29.272h2.148v2.737h-7.318v-2.737h1.977l-.788-4.486h-7.386l-.57 4.486h1.977v2.737zm13.178-10.416l-3.209-15.67-3.006 15.67zM6250.694-2481.066v2.737h-2.661l-5.664 29.272h-3.223l-6.243-29.272h-2.148v-2.737h7.318v2.737h-1.977l.788 4.486h7.385l.57-4.486h-1.976v-2.737zm-13.178 10.416l3.208 15.67 3.007-15.67z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/AD.ca5d744d972f5ef0fad1b1daf9e420c8.svg";
export { ForwardRef as ReactComponent };